export default [
  'onEnter',
  (nextState) => {
    const actionContext = nextState.routes[0].getContext().getActionContext();
    actionContext.service.create('googleAnalytics', { path: nextState.location.pathname });
  },
  (newOnEnter, oldOnEnter) => (nextState, replace, done) => {
    newOnEnter(nextState);
    if (oldOnEnter) {
      oldOnEnter(nextState, replace, done);
    } else {
      done();
    }
  }
];



// WEBPACK FOOTER //
// ./src/utils/route/googleAnalyticsDecoratorArgs.js